import { render, staticRenderFns } from "./m-documents-api-action-status.vue?vue&type=template&id=22404a34&scoped=true&lang=pug"
import script from "./m-documents-api-action-status.vue?vue&type=script&lang=js"
export * from "./m-documents-api-action-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22404a34",
  null
  
)

export default component.exports